import React, { useEffect, useState } from 'react'
import { Typography, makeStyles, Grid, Select, Box } from '@material-ui/core';
import { Button, Divider, TextField ,FormHelperText,Tooltip} from "@material-ui/core";
import { withStyles } from '@material-ui/styles';
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import { useSelector } from 'react-redux';
import EApplicantDetails from './view/e_applicant-details.js';
import EExistingApplicantDetails from './view/e_existing_applicant-details'
import EApplicantInfoGroup from './view/e_applicant-info-group-tag';
import { store } from "../../../helpers";
import { useTranslation } from "react-i18next";
import { ticketService } from '../model/_service';
import { CircularProgress } from "@material-ui/core";
import { Skeleton } from '@material-ui/lab';
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import OutlinedInput from '@material-ui/core/OutlinedInput';

const OutlinedTextFiled = withStyles((theme) => ({
  root: {
    "& input::placeholder": {
      fontSize: "0.75rem !important",
    },
    "& .MuiOutlinedInput-input": {
      padding: "0.62rem  !important",
    },
    "& .MuiInputBase-input": {
      fontSize: "0.75rem !important",
    },
     "& .MuiInputBase-input:focus": {
      fontSize: "1rem !important",
    },
    "& .MuiFormHelperText-root.Mui-error": {
      color: theme?.palette?.eDanger?.dark,
    },
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: theme?.palette?.eDanger?.dark
    },
    "& ::placeholder": {
      color: theme?.palette?.eDark?.base
    },
  },
}))(TextField);

const useStyles = makeStyles((theme) => ({
  secondaryColor: {
    color: theme.palette.ePrimary.base + " !important",
  },
  displayInline: {
    display: "inline",
    marginRight: 10
  },
  displayBlockMobile: {
    [theme.breakpoints.down("xs")]: {
      display: "block !important",
    },
  },
  checkboxLeftPadMobile: {
    [theme.breakpoints.down("xs")]: {
      paddingLeft: "0 !important",
    },
  },
  radioPadding: {
    padding: 2,
    paddingLeft: "0.625rem"
  },
  paddingWholeGrid: {
    paddingTop: "0.938rem",
    minHeight: "57vh"
  },
  paddingApplincant: {
    paddingTop: "1.25rem",
  },
  paddingCompany: {
    paddingTop: "1.25rem",
  },
  divider: {
    marginBottom: "1rem",
    [theme.breakpoints.down("xs")]: {
      marginTop: "1rem"
    },
  },
  container: {
    justifyContent: "right",
    align: "right"
  },
  cancel: {
    color: theme.palette.ePrimary.base,
    marginTop: "0.25rem",
  },
  submit: {
    backgroundColor: theme.palette.ePrimary.base,
    color: theme.palette.eWhite.base,
    borderRadius: 30,
    "&:hover": {
      backgroundColor: theme.palette.ePrimary.hover,
    },
    padding: "3% 25%",
    marginLeft: "1rem",
    marginRight: "3rem"
  },
  disable: {
    backgroundColor: theme.palette.eLight.base,
    color: theme.palette.eRich.base,
    borderRadius: 30,
    padding: "3% 25%",
    marginLeft: "1rem",
    marginRight: "5rem"
  },
  dialogTitle: {
    color: theme.palette.eWhite.base,
    backgroundColor: theme.palette.ePrimary.base,
  },
  crossButton: {
    color: theme.palette.eWhite.base,
    position: 'absolute',
    right: 8,
    top: 15
  },
  root: {
    "& .MuiOutlinedInput-input": {
      padding: "8px 8px !important",
    },
    "& .MuiInputBase-root": {
      marginTop: 3,
      fontSize: "0.8rem",
    },
    "& .MuiFormHelperText-root.Mui-error": {
      color: theme.palette.eDanger?.dark,
    },
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.eDanger?.dark
    },
    "& ::placeholder": {
      color: theme.palette.eDark?.base,
      fontSize: "0.75rem"
    },
    marginBottom : 3
  },
  errorColor: {
    color: theme.palette.eDanger.dark,
    marginTop: "0px",
    [theme.breakpoints.between("md", "xl")]: {
      marginBottom: "1%",
    },
  },
  alertIcon: {
    color: theme?.palette?.eTertiary?.base,
    width: "4rem",
    height: "auto",
    display: "block",
    margin: "1rem auto",

  },
  yes: {
    backgroundColor: theme.palette.ePrimary.base,
    color: theme.palette.eWhite.base,
    borderRadius: 30,
    "&:hover": {
      backgroundColor: theme.palette.ePrimary.hover,
    },
    padding: "3% 35%",
  },
  no: {
    color: theme.palette.ePrimary.base,
  },
  paddingTwoPercant: {
    padding: "2%",
    paddingBottom: "0%",
    minHeight: "inherit"
  },
  cancelNextAlign: {
    justifyContent: "right",
    align: "right",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "center",
    },
  },
  asterisk: {
    color: theme.palette.eDanger?.dark
  },
  secondaryColor: {
    color: theme.palette.ePrimary.base + " !important",
  },
  radioPadding: {
    padding: 2,
    paddingLeft: "0.625rem"
  },
  customerPadding: {
    [theme.breakpoints.up("md")]: {
      paddingRight: "1.5rem"
    },
  },
  customerPadding1: {
    // [theme.breakpoints.up("md")]: {
      paddingLeft: "34px"
    // },
  },
  errorMsgRightAlign: {
    "& .MuiFormHelperText-contained": {
      marginLeft: 0,
      marginRight: 0,
    }
  },
  circularLoading:{
    color : theme.palette.eWhite.base,
    marginLeft: 5,
    marginBottom: -2,
  },
  nextButton:{
    whiteSpace:"nowrap"
  },
  searchIcon:{
    color:theme?.palette?.eMedium?.base
  },
  searchIconPadding:{
    padding:"0px"
  }
}))

function EApplicantDetailsControl(props) {
  const {
    noofconnections,
    setnoofconnections,
    name,
    setName,
    fatherName,
    setFatherName,
    husbandName,
    setHusbandName,
    motherName,
    setMotherName,
    email,
    setEmail,
    openMobileDialog,
    setOpenMobileDialog,
    mobile,
    setMobile,
    idType,
    setIdType,
    idValue,
    setIdValue,
    setTinValue,
    tinValue,
    individualVerifiedMobile,
    setIndividualVerifiedMobile,
    tarrifType,
    setTarrifType,
    Load,
    setLoad,
    meterType,
    setMeterType,
    setDropDownData,
    dropDownData,
    isIndividualMobileVerified,
    setIsIndividualMobileVerified,
    setActiveStep,
    existingCustomer,
    setexistingCustomer,
    existingCustomerID,
    setexistingCustomerID,
    connectionType,
    setconnectionType,
    setConnectionTypeCode,
    setDocumentList,
    setIdTypeCode,
    setTinTypeCode,
    setTarrifTypeCode,
    setMeterTypeCode,
    setDocumentCodeList,
    setexistingPremisesList,
    husbandWifeRadio,
    sethusbandWifeRadio,
    idTypeCode,
    tinTypeCode,
    getDetails,
    MasterDataDetailsError,
    setMasterDataDetailsError,
    existingCustomerNotValid,
    setexistingCustimerNotValid,
    userEnteredMobileNumber,
    setuserEnteredMobileNumber,
    masterDataEmail,
    masterDataName,
    masterDataFatherName,
    masterDataMotherName,
    masterDataHusbandName,
    masterDatahusbandWifeRadio,
    masterDataIdValue,
    masterDataTinValue
  } = props

  const classes = useStyles();
  const applicantLabels = useSelector((state) => state?.labels?.data?.getLabels?.E_APPLICANT_DETAILS);
  const primaryLanguage = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE);
  const mobileRegex = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_APPLICANT_MOBILE_REGEX);
  const customerNumberLength = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_CUSTOMER_NO_LENGTH);
  const { t: applicantLabel, ready: applicantLabelReady } = useTranslation("label-E_APPLICANT_DETAILS");

  const [individualMobileVerificationError, setindividualMobileVerificationError] = useState(false);
  const [submitClicked, setSubmitClicked] = useState()
  const [isLoading, setisLoading] = useState(false);

  const [nameRequire, setnameRequire] = useState(false);
  const [nameError, setnameError] = useState(false);
  const [fatherNameError, setfatherNameError] = useState(false);
  const [fathernameRequire, setfathernameRequire] = useState(false);
  const [husbandNameError, sethusbandNameError] = useState(false);
  const [motherNameError, setmotherNameError] = useState(false);
  const [emailError, setemailError] = useState(false);
  const [mobileRequire, setmobileRequire] = useState(false);
  const [mobileError, setmobileError] = useState(false);
  const [idTypeRequire, setidTypeRequire] = useState(false);
  const [connectionTypeRequire, setconnectionTypeRequire] = useState(false);
  const [idValueRequire, setidValueRequire] = useState(false);
  const [idValueError, setidValueError] = useState(false)
  const [tinValueRequire, setTinValueRequire] = useState(false);
  const [tinValueError, setTinValueError] = useState(false)
  const [existingCustomerIDRequire, setexistingCustomerIDRequire] = useState(false)
  const [emailRequire, setemailRequire] = useState(false);
  const [noOfConnectionsRequired,setnoOfConnectionsRequired]=useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setMasterDataDetailsError(false);
    setexistingCustomerIDRequire(false);
    if (name === "existingCustomerID") {
      setexistingCustimerNotValid(false)
      const re = RegExp(mobileRegex)
      if (value === ""
        || re.test(event.target.value)
      ) {
        setexistingCustomerID(value);
      }
    }
    else if (name == "existingCustomer") {
      setexistingCustomer(value)
    }
  };
 
  const keyPress = (e) => {
    if (e.key === "Enter") {
  if(existingCustomerID.length==customerNumberLength){
    getDetails()
  }else{
    setexistingCustimerNotValid(true)
  }
      e.preventDefault();
    }
  };
function validateFieldsForExistingCustomer(){
  if (connectionType == "") {
    setconnectionTypeRequire(true);
  }else{
    setActiveStep(1);
  }
}

  function validateFields(existingCustomerNotValidlocal){
    if (
      name != "" &&
      !nameError &&
      !emailError &&
      mobile != "" &&
      !mobileError &&
      fatherName !="" &&
      !fatherNameError &&
      !husbandNameError &&
      !motherNameError &&
      idType != "" &&
      !idValueError &&
      isIndividualMobileVerified &&
      !existingCustomerNotValidlocal &&
      (existingCustomer == "yes" ? existingCustomerID != "" : true) &&
      idValue != ""
    ) {
      setActiveStep(1);
    } else {
      if (name == "") {
        setnameRequire(true);
      }
      if (fatherName == "") {
        setfathernameRequire(true);
      }
      if (email == "") {
        setemailRequire(true);
      }
      if (mobile == "") {
        setmobileRequire(true);
      }
      if (idType == "") {
        setidTypeRequire(true);
      }
      if (connectionType == "") {
        setconnectionTypeRequire(true);
      }
      if (idValue == "") {
        setidValueRequire(true);
      }
      if(tinValue==""){
        setTinValueRequire(true)
      }
      if (!isIndividualMobileVerified) {
        setindividualMobileVerificationError(true)
      }
      if (existingCustomer == "yes" && existingCustomerID == "") {
        setexistingCustomerIDRequire(true);
      }
    }
  }

  const submitClickHandle = () => {
    setSubmitClicked(true);
    if((existingCustomer == "yes" && existingCustomerID != "")){
      setisLoading(true)
      ticketService
        .getExistingPremiseDetails(existingCustomerID)
        .then((res) => {
          setisLoading(false);
          if(!res?.data?.ExistingPremise?.personId){
            setexistingCustimerNotValid(true);
            validateFieldsForExistingCustomer();
          } else{
            if(Array.isArray(res?.data?.ExistingPremise?.personDetails)){
              setexistingPremisesList(res?.data?.ExistingPremise?.personDetails)
            } else {
              setexistingPremisesList([res?.data?.ExistingPremise?.personDetails])
            }
            validateFieldsForExistingCustomer();
          }
        })
        .catch(err => {
          setisLoading(false);
          setexistingPremisesList(null);
          setexistingCustimerNotValid(true);
          validateFieldsForExistingCustomer();
        })
    } else {
      validateFields()
    }
  }

  useEffect(() => {
    if (submitClicked) {
      if (isIndividualMobileVerified) {
        setindividualMobileVerificationError(false)
      } else {
        setindividualMobileVerificationError(true)
      }
    }
  }, [isIndividualMobileVerified])

  const existingCustomerIDBlur = () => {
    if (existingCustomerID) {
      setexistingCustomerIDRequire(false);
      if (existingCustomerID.length == Number(customerNumberLength)) {
        setexistingCustimerNotValid(false);
      } else {
        setexistingCustimerNotValid(true);
      }
    } else {
      setexistingCustomerIDRequire(true);
    }
  }
const noofconnectionsBlur=()=>{
if(!noofconnections){
  setnoOfConnectionsRequired(true);
}else{
  setnoOfConnectionsRequired(false  );
}

}
  return (
    <Grid className={classes.paddingTwoPercant}>
      <Grid container spacing={0} className={classes.customerPadding}>
        <Grid item xs={12} md={6}>
          <Grid container className={classes.paddingApplincant}>
            <Grid item xs={12}>
              <Grid container spacing={0} direction="row">
                <Grid item xs={12} sm={6} md={6}>
                  <Box className={classes.boxPaddingRight}>
                    <Grid container spacing={1} direction="row">
                      <Grid item xs={12}>
                      {
                        applicantLabelReady ?
                        <Typography variant="subtitle2" className={[classes.secondaryColor, classes.displayInline]}>
                          <b>{applicantLabel("E_APPLICANT_EXISTING_CUSTOMER")}</b>
                        </Typography>
                        : <Skeleton />
                      }
                        <FormControl component="fieldset">
                          <RadioGroup
                            aria-label="gender"
                            row
                            name="existingCustomer"
                            value={existingCustomer}
                            onChange={handleChange}
                          >
                            <FormControlLabel
                              value="yes"
                              control={<Radio className={[classes.secondaryColor, classes.radioPadding]} />}
                              label={applicantLabelReady ? applicantLabel("E_APPLICANT_YES") : ''}
                            />
                            <FormControlLabel
                              value="no"
                              control={<Radio className={[classes.secondaryColor, classes.radioPadding]} />}
                              label={applicantLabelReady ? applicantLabel("E_APPLICANT_NO") : ''}
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={6} className={classes.customerPadding}>
                  <Box className={classes.boxPaddingRight}>
                    <Grid container spacing={1} direction="row">
                      <Grid item xs={12}>
                        {existingCustomer == "yes" &&
                          <>
                          {
                            applicantLabelReady ? 
                            <Typography variant="caption">
                              {applicantLabel("E_APPLICANT_CUSTOMER_id")}<span className={classes.asterisk}>*</span>
                            </Typography>
                            : <Skeleton />
                          }
                            <OutlinedInput
                              variant="outlined"
                              name="existingCustomerID"
                              fullWidth
                              className={[classes.root,classes.errorMsgRightAlign]}
                              endAdornment={
                                <InputAdornment><Tooltip title={applicantLabelReady ?applicantLabel("E_APPLICANT_CUSTOMER_id_SEARCH_TOOLTIP"):""}><IconButton className={classes.searchIconPadding} onClick={getDetails} ><SearchIcon /></IconButton></Tooltip></InputAdornment>
                              }
                              inputProps={{
                                
                                maxLength: Number(customerNumberLength),
                              }}
                              value={existingCustomerID}
                              onChange={handleChange}
                              onKeyPress={keyPress}
                              onBlur={existingCustomerIDBlur}
                              error={existingCustomerIDRequire || MasterDataDetailsError || existingCustomerNotValid}
                              autoComplete="off"
                              placeholder={applicantLabelReady ? applicantLabel("E_APPLICANT_CUSTOMER_id_PLACEHOLDER") : ''}
                             
                            />
                            {(existingCustomerIDRequire || MasterDataDetailsError ||existingCustomerNotValid)?<FormHelperText className={classes?.errorColor}>
                            {existingCustomerIDRequire === true ? (
                                  applicantLabelReady ?applicantLabel("E_APPLICANT_CUSTOMER_id") + applicantLabels?.E_APPLICANT_REQUIRED : ''
                                ) : 
                                existingCustomerNotValid ?  (applicantLabelReady ? applicantLabel("E_APPLICANT_CUSTOMER_id") + applicantLabels?.E_APPLICANT_NOT_VALID : '') :
                                MasterDataDetailsError?(applicantLabelReady ? applicantLabel("E_APPLICANT_CUSTOMER_id_NOT_FOUND"):""):""
                                (
                                  <div>&nbsp;</div>
                                )}
            </FormHelperText>:null}
                          </>}
                      </Grid>

                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6} md={6} className={classes.customerPadding1}>
          <Grid container className={classes.paddingApplincant}>
            <Grid item xs={12} >
              <Grid container spacing={0} direction="row" >
              <Grid item xs={12} sm={6} md={6} className={classes.customerPadding}>
                  <Box className={classes.boxPaddingRight}>
                    <Grid container spacing={1} direction="row">
                      <Grid item xs={12}>
                  
                          <>
                          {
                            applicantLabelReady ? 
                            <Typography variant="caption">
                              {applicantLabel("E_NO_OF_CONNECTIONS")}<span className={classes.asterisk}>*</span>
                            </Typography>
                            : <Skeleton />
                          }

                            <OutlinedTextFiled
                              variant="outlined"
                              name="noofconnections"
                              fullWidth
                              inputProps={{
                                maxLength: Number(1),
                              }}
                              value={noofconnections}
                              onChange={
                        (e)=>setnoofconnections(e.target.value)
                              }
                              onBlur={noofconnectionsBlur}
                              error={noOfConnectionsRequired}
                              autoComplete="off"
                              helperText={
                                noOfConnectionsRequired === true ? (
                                  applicantLabelReady ?applicantLabel("E_NO_OF_CONNECTIONS") + applicantLabels?.E_APPLICANT_REQUIRED : ''
                                ):null
                              }
                              placeholder={applicantLabelReady ? applicantLabel("E_NO_OF_CONNECTIONS_PLACEHOLDER") : ''}
                              className={[classes.errorMsgRightAlign]}
                            />
                          </>
                      </Grid>

                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid container spacing={5} className={[classes.paddingWholeGrid]}>
        <Grid item xs={12} md={6}>
          <Typography className={[classes.secondaryColor, classes.displayInline]}>
            <b>{applicantLabels?.E_APPLICANT_APPLICANT_DETAILS}</b>
          </Typography>
          <Grid container className={classes.paddingApplincant}>
            {existingCustomer=="yes"?
             <Grid item xs={12}>
             <EExistingApplicantDetails
               husbandWifeRadio={husbandWifeRadio}
               sethusbandWifeRadio={sethusbandWifeRadio}
               existingCustomer={existingCustomer}
               userEnteredMobileNumber={userEnteredMobileNumber}
              setuserEnteredMobileNumber={setuserEnteredMobileNumber}
              masterDataEmail={masterDataEmail}
           masterDataName={masterDataName}
           masterDataFatherName={masterDataFatherName}
           masterDataMotherName={masterDataMotherName}
           masterDataHusbandName={masterDataHusbandName}
           masterDatahusbandWifeRadio={masterDatahusbandWifeRadio}
             />
           </Grid>
            :
            <Grid item xs={12}>
              <EApplicantDetails
                name={name}
                setName={setName}
                fatherName={fatherName}
                setFatherName={setFatherName}
                husbandName={husbandName}
                setHusbandName={setHusbandName}
                motherName={motherName}
                setMotherName={setMotherName}
                email={email}
                setEmail={setEmail}
                openMobileDialog={openMobileDialog}
                setOpenMobileDialog={setOpenMobileDialog}
                mobile={mobile}
                setMobile={setMobile}
                individualVerifiedMobile={individualVerifiedMobile}
                setIndividualVerifiedMobile={setIndividualVerifiedMobile}
                nameRequire={nameRequire}
                setnameRequire={setnameRequire}
                nameError={nameError}
                setnameError={setnameError}
                fathernameRequire={fathernameRequire}
                setfathernameRequire={setfathernameRequire}
                fatherNameError={fatherNameError}
                setfatherNameError={setfatherNameError}
                husbandNameError={husbandNameError}
                sethusbandNameError={sethusbandNameError}
                motherNameError={motherNameError}
                setmotherNameError={setmotherNameError}
                emailError={emailError}
                emailRequire={emailRequire}
                setemailRequire={setemailRequire}
                setemailError={setemailError}
                mobileRequire={mobileRequire}
                setmobileRequire={setmobileRequire}
                mobileError={mobileError}
                setmobileError={setmobileError}
                isMobileVerified={isIndividualMobileVerified}
                setIsMobileVerified={setIsIndividualMobileVerified}
                individualMobileVerificationError={individualMobileVerificationError}
                setindividualMobileVerificationError={setindividualMobileVerificationError}
                husbandWifeRadio={husbandWifeRadio}
                sethusbandWifeRadio={sethusbandWifeRadio}
                existingCustomer={existingCustomer}
                userEnteredMobileNumber={userEnteredMobileNumber}
               setuserEnteredMobileNumber={setuserEnteredMobileNumber}
               masterDataEmail={masterDataEmail}
            masterDataName={masterDataName}
            masterDataFatherName={masterDataFatherName}
            masterDataMotherName={masterDataMotherName}
            masterDataHusbandName={masterDataHusbandName}
            masterDatahusbandWifeRadio={masterDatahusbandWifeRadio}
              />
            </Grid>
}
          </Grid>
        </Grid>
        <Grid item xs={12} md={6}>
        {
          applicantLabelReady ?
          <Typography className={[classes.secondaryColor, classes.displayInline, classes.displayBlockMobile]}>
            <b>{applicantLabel("E_APPLICANT_INFO_GROUP_TAG")}</b>
          </Typography>
          : <Skeleton />
        }

          <Grid container className={classes.paddingCompany}>
            <Grid item xs={12}>

              <EApplicantInfoGroup
                tarrifType={tarrifType}
                setTarrifType={setTarrifType}
                Load={Load}
                setLoad={setLoad}
                meterType={meterType}
                setMeterType={setMeterType}
                idType={idType}
                setIdType={setIdType}
                idValue={idValue}
                setIdValue={setIdValue}
                tinValue={tinValue}
                setTinValue={setTinValue}
                setTinTypeCode={setTinTypeCode}
                idTypeRequire={idTypeRequire}
                setidTypeRequire={setidTypeRequire}
                idValueRequire={idValueRequire}
                tinValueRequire={tinValueRequire}
                setTinValueRequire={setTinValueRequire}
                setidValueRequire={setidValueRequire}
                connectionTypeRequire={connectionTypeRequire}
                setconnectionTypeRequire={setconnectionTypeRequire}
                connectionType={connectionType}
                setconnectionType={setconnectionType}
                setConnectionTypeCode={setConnectionTypeCode}
                setDropDownData={setDropDownData}
                dropDownData={dropDownData}
                setDocumentList={setDocumentList}
                setDocumentCodeList={setDocumentCodeList}
                setIdTypeCode={setIdTypeCode}
                setTarrifTypeCode={setTarrifTypeCode}
                setMeterTypeCode={setMeterTypeCode}
                idValueError={idValueError}
                tinValueError={tinValueError}
                setidValueError={setidValueError}
                setTinValueError={setTinValueError}
                idTypeCode={idTypeCode}
                tinTypeCode={setTinTypeCode}
                existingCustomer={existingCustomer}
                MasterDataDetailsError={MasterDataDetailsError}
                existingCustomerIDRequire={existingCustomerIDRequire}
                existingCustomerNotValid={existingCustomerNotValid}
                masterDataIdValue={masterDataIdValue}
                masterDataTinValue={masterDataTinValue}
              />
            </Grid>
          </Grid>
        </Grid>

      </Grid>
      <Divider className={classes.divider} />
      <Grid container className={classes.cancelNextAlign}>
        <Grid item>
          <Button
            className={(MasterDataDetailsError || existingCustomerIDRequire|| existingCustomerNotValid) ?classes.disable:classes.submit}
            size="small"
            align="right"
            disabled={MasterDataDetailsError || existingCustomerIDRequire|| existingCustomerNotValid}
            onClick={submitClickHandle}
          >
            <Typography variant="button" className={classes.nextButton}>{applicantLabels?.E_APPLICANT_NEXT}{isLoading && <CircularProgress className={classes.circularLoading} size={12}/>}</Typography>
          </Button>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default EApplicantDetailsControl